export default __webpack_public_path__ + "static/media/photos-etiquettes.9a097d22.svg";